
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, option_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { stringHash, Lazy } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { replace, substring } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Layout_placeLines, Layout_codeValueFontSizePt, Layout_layout } from "../Shared/Label.js";
import { codeImage } from "../Components/LabelPreview.js";
import { min } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { head, tail, iterateIndexed, isEmpty, iterate } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { jsPDF } from "jspdf";
import { onBlobReceived } from "../Communication.js";
import jszip from "jszip";
import { List_groupBy } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";

export class PdfFonts extends Record {
    constructor(Family, Regular, Bold) {
        super();
        this.Family = Family;
        this.Regular = Regular;
        this.Bold = Bold;
    }
}

export function PdfFonts_$reflection() {
    return record_type("Labels.LabelPdf.PdfFonts", [], PdfFonts, () => [["Family", string_type], ["Regular", option_type(string_type)], ["Bold", option_type(string_type)]]);
}

const fallbackFonts = new PdfFonts("helvetica", undefined, undefined);

const loadFonts = new Lazy(() => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((fetch("/assets/fonts/Ubuntu-Regular.ttf").then(function(r){ if (!r.ok) { return null; } return r.arrayBuffer(); }).then(function(b){ if (!b) { return null; } var bytes = new Uint8Array(b); var binary = ''; for (var i = 0; i < bytes.length; i++) { binary += String.fromCharCode(bytes[i]); } return btoa(binary); }).catch(function(){ return null; })).then((_arg) => {
    const regular = _arg;
    return (fetch("/assets/fonts/Ubuntu-Bold.ttf").then(function(r){ if (!r.ok) { return null; } return r.arrayBuffer(); }).then(function(b){ if (!b) { return null; } var bytes = new Uint8Array(b); var binary = ''; for (var i = 0; i < bytes.length; i++) { binary += String.fromCharCode(bytes[i]); } return btoa(binary); }).catch(function(){ return null; })).then((_arg_1) => {
        const bold = _arg_1;
        return (((Operators_IsNull(regular) ? true : Operators_IsNull(bold)) ? true : (regular === "")) ? true : (bold === "")) ? (Promise.resolve(fallbackFonts)) : (Promise.resolve(new PdfFonts("Ubuntu", regular, bold)));
    });
})))));

function registerFonts(doc, fonts) {
    const matchValue = fonts.Regular;
    const matchValue_1 = fonts.Bold;
    let matchResult, bold, regular;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            bold = matchValue_1;
            regular = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            doc.addFileToVFS("Ubuntu-Regular.ttf", regular);
            doc.addFont("Ubuntu-Regular.ttf", fonts.Family, "normal");
            doc.addFileToVFS("Ubuntu-Bold.ttf", bold);
            doc.addFont("Ubuntu-Bold.ttf", fonts.Family, "bold");
            break;
        }
        case 1: {
            break;
        }
    }
}

export function loadLogo(logoUrl) {
    if (logoUrl != null) {
        const url = logoUrl;
        const pr = fetch(url).then(function(r){ if (!r.ok) { return null; } return r.blob(); }).then(function(b){ if (!b) { return null; } return new Promise(function(resolve){ var reader = new FileReader(); reader.onloadend = function(){ resolve(reader.result); }; reader.onerror = function(){ resolve(null); }; reader.readAsDataURL(b); }); }).catch(function(){ return null; });
        return pr.then((dataUrl) => {
            if (Operators_IsNull(dataUrl) ? true : (dataUrl === "")) {
                return undefined;
            }
            else {
                return dataUrl;
            }
        });
    }
    else {
        return Promise.resolve(undefined);
    }
}

const ellipsis = "…";

function fitText(doc, text, maxWidth) {
    if ((doc.getTextWidth(text)) <= maxWidth) {
        return text;
    }
    else {
        const shorten = (candidate_mut) => {
            shorten:
            while (true) {
                const candidate = candidate_mut;
                if (candidate === "") {
                    return ellipsis;
                }
                else if ((doc.getTextWidth(candidate + ellipsis)) <= maxWidth) {
                    return candidate + ellipsis;
                }
                else {
                    candidate_mut = substring(candidate, 0, candidate.length - 1);
                    continue shorten;
                }
                break;
            }
        };
        return shorten(substring(text, 0, text.length - 1));
    }
}

function measureTextWidthMm(doc, family, fontSizePt, bold, text) {
    doc.setFont(family, (bold ? "bold" : "normal"));
    doc.setFontSize(fontSizePt);
    return doc.getTextWidth(text);
}

function drawLine(doc, family, textBox, placed) {
    doc.setFont(family, (placed.Line.Bold ? "bold" : "normal"));
    doc.setFontSize(placed.FontSizePt);
    doc.text(fitText(doc, placed.Line.Content, textBox.Width), textBox.X, (placed.Y + (placed.Height / 2)), { baseline: 'middle', align: "left" });
}

function drawLabel(doc, configuration, code, lines, logoDataUrl, fonts) {
    let textBox;
    const layout = Layout_layout(configuration);
    doc.setTextColor(0, 0, 0);
    const matchValue = layout.CodeBox;
    const matchValue_1 = codeImage(configuration.CodeType, code);
    let matchResult, codeBox, image;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            codeBox = matchValue;
            image = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            doc.addImage(image, 'PNG', codeBox.X, codeBox.Y, codeBox.Width, codeBox.Height);
            break;
        }
    }
    const matchValue_3 = layout.CodeValueBox;
    if (matchValue_3 == null) {
    }
    else {
        const valueBox = matchValue_3;
        doc.setFont(fonts.Family, "normal");
        doc.setFontSize(Layout_codeValueFontSizePt(valueBox));
        doc.text(fitText(doc, code, valueBox.Width), (valueBox.X + (valueBox.Width / 2)), (valueBox.Y + (valueBox.Height / 2)), { baseline: 'middle', align: "center" });
    }
    const matchValue_4 = layout.LogoBox;
    let matchResult_1, logo, logoBox;
    if (matchValue_4 != null) {
        if (logoDataUrl != null) {
            matchResult_1 = 0;
            logo = logoDataUrl;
            logoBox = matchValue_4;
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            const aspect = (function(d, u){ try { var p = d.getImageProperties(u); return p.width / p.height; } catch(e){ return 0; } })(doc, logo);
            if (aspect > 0) {
                const width = min(logoBox.Width, logoBox.Height * aspect);
                const height = width / aspect;
                doc.addImage(logo, 'PNG', ((logoBox.X + logoBox.Width) - width), logoBox.Y, width, height);
            }
            break;
        }
    }
    const matchValue_6 = layout.TextBox;
    let matchResult_2, textBox_1;
    if (matchValue_6 != null) {
        if ((textBox = matchValue_6, !isEmpty(lines))) {
            matchResult_2 = 0;
            textBox_1 = matchValue_6;
        }
        else {
            matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            iterate((placed) => {
                drawLine(doc, fonts.Family, textBox_1, placed);
            }, Layout_placeLines((fontSizePt, bold, text) => measureTextWidthMm(doc, fonts.Family, fontSizePt, bold, text), textBox_1, lines));
            break;
        }
        case 1: {
            break;
        }
    }
}

export function labelDocument(configuration, code, lines, logoDataUrl, fonts) {
    const doc = new jsPDF({ unit: 'mm', format: [configuration.WidthMm, configuration.HeightMm], orientation: configuration.WidthMm >= configuration.HeightMm ? 'landscape' : 'portrait', compress: true });
    registerFonts(doc, fonts);
    drawLabel(doc, configuration, code, lines, logoDataUrl, fonts);
    return doc;
}

export function combinedDocument(configuration, labels, logoDataUrl, fonts) {
    const doc = new jsPDF({ unit: 'mm', format: [configuration.WidthMm, configuration.HeightMm], orientation: configuration.WidthMm >= configuration.HeightMm ? 'landscape' : 'portrait', compress: true });
    registerFonts(doc, fonts);
    iterateIndexed((index, label) => {
        if (index > 0) {
            doc.addPage([configuration.WidthMm, configuration.HeightMm], configuration.WidthMm >= configuration.HeightMm ? 'landscape' : 'portrait');
        }
        drawLabel(doc, configuration, label.Code, label.Lines, logoDataUrl, fonts);
    }, labels);
    return doc;
}

export function labelBlob(configuration, code, lines, logoDataUrl, fonts) {
    const doc = labelDocument(configuration, code, lines, logoDataUrl, fonts);
    return doc.output('blob');
}

export function downloadBlob(blob, fileName) {
    return onBlobReceived(blob, fileName);
}

export function downloadSingleLabel(configuration, code, lines, logoUrl, fileName) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (loadFonts.Value.then((_arg) => (loadLogo(logoUrl).then((_arg_1) => {
        downloadBlob(labelBlob(configuration, code, lines, _arg_1, _arg), fileName);
        return Promise.resolve();
    }))))));
}

export const zipFileName = "etiketten.zip";

export const combinedFileName = "etiketten-gesamt.pdf";

export function downloadPrintedLabels(configuration, labels, logoUrl) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (loadFonts.Value.then((_arg) => {
        const fonts = _arg;
        return loadLogo(logoUrl).then((_arg_1) => {
            let doc;
            const logo = _arg_1;
            if (!isEmpty(labels)) {
                if (isEmpty(tail(labels))) {
                    downloadBlob(labelBlob(configuration, head(labels).Code, head(labels).Lines, logo, fonts), head(labels).FileName);
                    return Promise.resolve();
                }
                else {
                    const zip = new jszip();
                    iterate((tupledArg) => {
                        const fileName = tupledArg[0];
                        iterateIndexed((index, label_2) => {
                            const name = (index === 0) ? fileName : replace(fileName, ".pdf", `-${index + 1}.pdf`);
                            zip.file(name, labelBlob(configuration, label_2.Code, label_2.Lines, logo, fonts));
                        }, tupledArg[1]);
                    }, List_groupBy((label_1) => label_1.FileName, labels, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: (x) => (stringHash(x) | 0),
                    }));
                    zip.file(combinedFileName, ((doc = combinedDocument(configuration, labels, logo, fonts), doc.output('blob'))));
                    return (zip.generateAsync({ type: 'blob' })).then((_arg_2) => {
                        downloadBlob(_arg_2, zipFileName);
                        return Promise.resolve();
                    });
                }
            }
            else {
                return Promise.resolve();
            }
        });
    }))));
}

